<template>
    <main>
        <div class="m-header"><div class="top"></div></div>
        <div class="bg">
            <div class="left crumbs-box">
                <div class="tit">{{crumbs.title}}</div>
                <div class="min-tit">{{crumbs.min_title}}</div>
            </div>
            <div class="right logo" style="display: none;">
                <img :src="require('@/assets/image/2021/20.png')" alt="">
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'crumbs',
        data() {
            return {
                query:"",
            }
        },
        props:{
            crumbs:{
                type:Object,
                default:[]
            }
        },
        components:{

        },
        computed:{

        },
        methods: {

        },
        mounted() {
            this.query = this.$route.query;
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .m-header{
        .top{position: fixed; height:.88rem;overflow: hidden;top:0;left:0;width:100%;z-index: 99;background: url("~@/assets/image/2026/mobile/nav-bg.png") no-repeat top center;background-size: 100% 2.3rem;}
    }
    .bg{padding-top:.88rem;height:1.42rem; background: url("~@/assets/image/2026/mobile/nav-bg.png") no-repeat top center;background-size: 100% 2.3rem;color: #fff;overflow: hidden;position: relative;
        .crumbs-box{ line-height: .4rem;font-size: .3rem;overflow: hidden;padding: .25rem;
            .tit{font-size: .46rem;line-height: .5rem;font-weight: bold;}
			.min-tit{font-size: .26rem;line-height: .35rem;margin-top: .06rem;font-weight: 100;opacity: .8;text-transform: uppercase;}
        }
        .logo{position:absolute;bottom:.2rem;right:.4rem;
            img{width:2.3rem;}
        }
    }
</style>

